// src/features/planning/components/SourcingBadge.tsx
// ADR-094 Rule MRP-FE-04.

import type { SourcingSuggestion } from "../types";

const STYLES: Record<SourcingSuggestion, { label: string; background: string; color: string }> = {
  make: { label: "تولید داخلی", background: "rgba(96,165,250,0.15)", color: "#60a5fa" },
  buy: { label: "خرید", background: "rgba(249,115,22,0.15)", color: "#f97316" },
};

export interface SourcingBadgeProps {
  value: SourcingSuggestion;
}

export function SourcingBadge({ value }: SourcingBadgeProps) {
  const { label, background, color } = STYLES[value];
  return (
    <span
      data-testid="mrp-sourcing-badge"
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        background,
        color,
      }}
    >
      {label}
    </span>
  );
}
